function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareBaseDiagram(_ref, svgRef) {
  var _ref2;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "100mm",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M255.368 117.887h38.546v23.128h-38.546z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.535292,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M37.768 30.268h24.465v49.465H37.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.421822,
      strokeLinejoin: "miter",
      strokeDasharray: ".843644,.421822",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M62.65 29.85 92.35.15M7.65 109.85l29.7-29.7M7.65.15l29.7 29.7M62.65 80.15l29.7 29.7"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "3.27068px",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      fontFamily: "sans-serif"
    },
    x: 39.128,
    y: 29.055,
    transform: "scale(1.02315 .97737)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 39.128,
    y: 29.055
  }, "Front Facing")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: (_ref2 = {
      fontFamily: "sans-serif"
    }, _defineProperty(_ref2, "fontFamily", "sans-serif"), _defineProperty(_ref2, "fontSize", "5.86371px"), _defineProperty(_ref2, "fill", "#000"), _defineProperty(_ref2, "fillOpacity", 1), _defineProperty(_ref2, "stroke", "none"), _defineProperty(_ref2, "strokeWidth", 0.184683), _defineProperty(_ref2, "strokeLinejoin", "miter"), _defineProperty(_ref2, "strokeDasharray", "none"), _defineProperty(_ref2, "strokeDashoffset", 0), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    x: 34.492,
    y: 7.602,
    transform: "scale(1.00973 .99036)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      strokeWidth: 0.184683
    },
    x: 34.492,
    y: 7.602
  }, "Front Arch")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "3.27068px",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 39.774,
    y: 84.701,
    transform: "scale(1.02315 .97737)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 39.774,
    y: 84.701
  }, "Rear Facing")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "3.175px",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.1,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 56.07,
    y: 88.101
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "3.27068px",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 61.859,
    y: 53.643,
    transform: "scale(1.02315 .97737)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 61.859,
    y: 53.643
  }, "Flank "), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 61.859,
    y: 57.731
  }, "Facing")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "3.27068px",
      direction: "rtl",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      imageRendering: "auto"
    },
    x: 36.367,
    y: 53.643,
    transform: "scale(1.02315 .97737)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "rtl",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 36.367,
    y: 53.643
  }, "Flank "), /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "rtl",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.103014,
      strokeDasharray: "none"
    },
    x: 36.367,
    y: 57.731
  }, "Facing")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "5.86371px",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.184683,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 35.445,
    y: 98.866,
    transform: "scale(1.00973 .99036)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      strokeWidth: 0.184683
    },
    x: 35.445,
    y: 98.866
  }, "Rear Arch")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "5.86371px",
      direction: "rtl",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.184683,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 97.342,
    y: 52.922,
    transform: "scale(1.00973 .99036)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "rtl",
      strokeWidth: 0.184683
    },
    x: 97.342,
    y: 52.922
  }, "Flank "), /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "rtl",
      strokeWidth: 0.184683
    },
    x: 97.342,
    y: 60.252
  }, "Arch")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontFamily: "sans-serif",
      fontSize: "5.86371px",
      direction: "ltr",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.184683,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    x: 0.925,
    y: 52.922,
    transform: "scale(1.00973 .99036)"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "ltr",
      strokeWidth: 0.184683
    },
    x: 0.925,
    y: 52.922
  }, "Flank "), /*#__PURE__*/React.createElement("tspan", {
    style: {
      direction: "ltr",
      strokeWidth: 0.184683
    },
    x: 0.925,
    y: 60.252
  }, "Arch")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(.26458 0 0 .26458 -4.537 -1.412)",
    style: {
      fontFamily: "sans-serif",
      direction: "ltr",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.377953,
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 255.367,
    y: 128.835
  }, "135\xB0 "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBaseDiagram);
export default __webpack_public_path__ + "static/media/square-base-diagram.f621c6e08992570ee53b3d0aac6e3e8c.svg";
export { ForwardRef as ReactComponent };